import { get, post } from './http-calls';

export const getTCards_ScreenDropdown = async (TCardID, isStatusDash) => {
    let queryParams = [];

    if (TCardID) {
        queryParams.push(`TCardID=${TCardID}`);
    }

    if (isStatusDash) {
        queryParams.push(`StatusDashboard=${isStatusDash}`);
    }

    const queryString = queryParams.length ? `?${queryParams.join('&')}` : '';

    let res = await get(`TCards/TCards_ScreenDropdown${queryString}`, {
        useAuthToken: true
    });

    return res;

};

export const getTCards_GetExistingTCards = async (VehicleID, headerRecordID) => {
    let res = await get(
        `TCards/TCards_GetExistingTCards?${VehicleID ? `VehicleID=${VehicleID}` : ''}${headerRecordID ? `headerRecordID=${headerRecordID}` : ''}`,
        {
            useAuthToken: true
        }
    );
    return res;
};

export const getTCards_ByID = async (TCardsID) => {
    let res = await get(`TCards/TCards_Get?TCardsID=${TCardsID}`, { useAuthToken: true });
    return res;
};

export const getTCards_GetByRegNumberYardCheck = async (RegNumber, BranchID) => {
    let res = await get(`YardCheck/TCards_GetByRegNumberYardCheck?RegNumber=${RegNumber}&BranchID=${BranchID}`, { useAuthToken: true });
    return res;
};

export const getTCards_GetVehicles = async (RegNumber) => {
    let res = await get(`TCards/TCards_GetVehicles?RegNumber=${RegNumber}`, { useAuthToken: true });
    return res;
};
export const TCards_GetExistingTCardsByRegNumber = async (RegNumber, br) => {
    let res = await get(`TCards/TCards_GetExistingTCardsByRegNumber?RegNumber=${RegNumber}${br ? `&BranchID=${br}` : ''}`, { useAuthToken: true });
    return res;
};

export const getCheckInTCards_GetByRegNumber = async (RegNumber) => {
    let res = await get(`TCards/TCards_GetByRegNumber?RegNumber=${RegNumber}`, { useAuthToken: true });
    return res;
};

export const getTCards_GetCustomerContacts = async (CustomerID) => {
    let res = await get(`Tcards/TCards_GetCustomerContacts?CustomerID=${CustomerID}`, { useAuthToken: true });
    return res;
};

export const getTCardMovementHistory_GET = async (TCardsID) => {
    let res = await get(`TCards/TCardMovementHistory_GET?TCardsID=${TCardsID}`, { useAuthToken: true });
    return res;
};

export const getTCards_GetPartReqsByHeaderRecordID = async (HeaderRecordID) => {
    let res = await get(`TCards/TCards_GetPartReqs?HeaderRecordID=${HeaderRecordID}`, { useAuthToken: true });
    return res;
};

export const getTCards_TCards_GetJobDetails = async (HeaderRecordID) => {
    let res = await get(`Tcards/TCards_GetJobDetails?HeaderRecordID=${HeaderRecordID}`, { useAuthToken: true });
    return res;
};



export const postTcardsAddUpdate = async (data) => {
    let res = await post(`TCards/TcardsAddUpdate`, data, { useAuthToken: true });
    return res;
};
export const postDeLinkTcards = async (ID) => {
    let res = await post(`TCards/TCards_DeLinkTCardeWIPJob?TCardID=${ID}`, {}, { useAuthToken: true });
    return res;
};

export const TCards_SerachJobs = async (RegNumber, br, Customer = '') => {
    let res = await get(`TCards/TCards_GetVehicleJobs?RegNumber=${RegNumber}${br ? `&BranchID=${br}` : ''}${Customer ? `&Customer=${Customer}` : ''}`, {
        useAuthToken: true
    });
    return res;
};

export const postTcardLinkedToJob = async (id, HeaderRecordID) => {
    let res = await post(`TCards/TCards_LinkTCardeWIPJob?TCardID=${id}&HeaderRecordID=${HeaderRecordID}`, {}, { useAuthToken: true });
    return res;
};

export const postTCardsLock_Save = async (TCardsID) => {
    let res = await post(`TCardLock/TCardsLock_Save?TCardsId=${TCardsID}`, {}, { useAuthToken: true });
    return res;
};
export const postTCardsLocks_ResetLock_Save = async (TCardsID) => {
    let res = await post(`TCardLock/TCardsLocks_ResetLock?Id=${TCardsID}`, {}, { useAuthToken: true });
    return res;
};

export const postTCards_Delete = async (TCardsID) => {
    let res = await post(`TCards/TCards_Delete?TCardID=${TCardsID}`, {}, { useAuthToken: true });
    return res;
};

export const postTCard_YardCheck = async (data) => {
    let res = await post(`YardCheck/TCard_YardCheck`, data, { useAuthToken: true });
    return res;
};

export const postTCardsLineItems_SwapSequence = async (TCardsLineItemsID1, TCardsLineItemsID2) => {
    let res = await post(
        `TCards/TCardsLineItems_SwapSequence?TCardsLineItemsID1=${TCardsLineItemsID1}&TCardsLineItemsID2=${TCardsLineItemsID2}`,
        {},
        { useAuthToken: true }
    );
    return res;
};
